<template>
  <div>
    <Navigation />
    <div class="grid__section">

    <section class="section__container top__container blog__details">
      <h1 class="title center__text">
        ENVOI SMS ENSEIGNEMENT / FORMATION / UNIVERSITÉS
      </h1>

      <img class="card__image" src="/../images/teach-80x80.png" alt="" />

      <p>
        Notre plateforme facilite la communication avec les parents d'élèves via des SMS en temps réel. 
      </p>
      <p>
        Simple, rapide et universel, cette solution est idéale pour les établissements scolaires tels que 
        les écoles maternelles, primaires, collèges, lycées, écoles privées, instituts de formation, universités, 
        et autres structures éducatives.
      </p>
      <p>
        Elle permet d'envoyer des alertes météo, des informations sur les grèves, les réunions parents-professeurs,
        les paiements, les bulletins de notes, les calendriers d'examens, les rattrapages, les nouvelles formations, 
        les admissions, et bien d'autres. 
      </p>
      <p>
        De nombreux établissements scolaires utilisent déjà notre solution SMS Scolaire.
      </p>
      <h2>Quelques exemples de SMS :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/phone1.png" />
          
        </div>

        <div class="card">
          <img class="card__image" src="/../images/phone2.png" />
         
        </div>
        <div class="card">
          <img class="card__image" src="/../images/phone3.png" />
         
          
        </div>
      </div>
    </section>
    
    
    <SideNav/>
    
    </div>


    <Footer />
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";




 

</style>
